(() => {
  const documentBody = document.querySelector('[data-policy-document]');
  const contents = document.querySelector('[data-policy-contents]');
  const links = document.querySelector('[data-policy-links]');
  if (!documentBody || !contents || !links) return;
  for (const paragraph of documentBody.querySelectorAll(':scope > p')) {
    const text = paragraph.textContent.trim();
    if (!text || /^[-–—\s]+$/.test(text)) { paragraph.remove(); continue; }
    if (text.length < 100 && !paragraph.querySelector('a') && ((paragraph.children.length === 1 && ['STRONG','B'].includes(paragraph.firstElementChild.tagName)) || /^(SECTION \d+|OVERVIEW$)/.test(text))) {
      const heading = document.createElement('h2');
      heading.textContent = text;
      paragraph.replaceWith(heading);
    }
  }
  for (const strong of documentBody.querySelectorAll(':scope > strong')) {
    if (!/^(SECTION \d+|OVERVIEW$)/.test(strong.textContent.trim())) continue;
    const heading = document.createElement('h2');
    heading.textContent = strong.textContent.trim();
    strong.replaceWith(heading);
    while (heading.nextSibling && (heading.nextSibling.nodeName === 'BR' || (heading.nextSibling.nodeType === Node.TEXT_NODE && !heading.nextSibling.textContent.trim()))) heading.nextSibling.remove();
  }
  const policyNav = document.querySelector('.sp-navigation');
  const activePolicy = policyNav?.querySelector('[aria-current]');
  const compact = matchMedia('(max-width:999px)');
  const centrePolicy = () => {
    if (activePolicy && compact.matches) policyNav.scrollLeft = activePolicy.offsetLeft - policyNav.offsetLeft - (policyNav.clientWidth - activePolicy.offsetWidth) / 2;
  };
  centrePolicy();
  compact.addEventListener('change', centrePolicy);
  const headings = [...documentBody.querySelectorAll('h2')];
  for (const [index, heading] of headings.entries()) {
    if (!heading.textContent.trim()) continue;
    heading.id ||= `policy-section-${index + 1}`;
    const link = document.createElement('a');
    link.href = `#${heading.id}`;
    link.textContent = heading.textContent.trim();
    links.append(link);
  }
  if (links.childElementCount > 1) {
    contents.hidden = false;
    const desktop = matchMedia('(min-width:1000px)');
    const syncContents = () => { contents.open = desktop.matches; };
    syncContents();
    desktop.addEventListener('change', syncContents);
  }
  contents.addEventListener('click', event => {
    if (event.target.closest('a') && matchMedia('(max-width:999px)').matches) contents.open = false;
  });
})();
